import { buttonClicked } from '@/rudder-typer';
import { PageSection } from '@/utils/analytics/PageSection';

export interface ButtonClickedPayload {
  buttonName: string;
  content?: string;
  pageSection?: PageSection<
    | 'Box Builder Quiz Page'
    | 'Buy Block'
    | 'Custom Snack Box Builder Catalogue'
    | 'Custom Snack Box Builder Search'
    | 'FTB Popup'
    | 'Hero Banner'
    | 'Mini PDP'
    | 'Quiz Modal'
  >;
}

export function sendButtonClicked({ buttonName, content, pageSection }: ButtonClickedPayload) {
  buttonClicked({
    button_name: buttonName,
    content,
    page_section: pageSection,
  });
}
